window.app.directive("ngLoad", [
  "$parse",
  function($parse) {
    return {
      restrict: "A",
      scope: false,
      link: function(scope, element, attrs) {
        var load = $parse(attrs.ngLoad);
        element.bind("load", function(ev) {
          window.requestAnimationFrame(function() {
            load(scope, { $event: ev });
            scope.$applyAsync(angular.noop);
          });
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/imgLoad.js